import ky from 'ky'

import { authCookie } from '@/lib/auth'

const kyApi = ky.create({
  headers: {
    'X-Platform': 'web',
    'X-Creator-Mail': 'rizqynugroho88@gmail.com',
  },
  hooks: {
    beforeRequest: [
      req => {
        const token = authCookie.get()
        if (token) {
          req.headers.set('Authorization', `Bearer ${token}`)
        }
      },
    ],
  },
  retry: {
    methods: ['get'],
  },
})

export { kyApi }
